module.exports = __webpack_public_path__ + "static/media/18x24no1.c88d685c.jpg";